(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-faq-img"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const faqItems = document.querySelectorAll(".about-faq-img-section .faq-item");

    // Function to close all FAQ items
    function closeAll() {
      faqItems.forEach(item => {
        item.classList.remove("open");
        const icon = item.querySelector(".faq-toggle-icon");
        if (icon) icon.textContent = "+";
      });
    }

    // Loop through each FAQ item
    faqItems.forEach(item => {
      const question = item.querySelector(".faq-question");
      const icon = item.querySelector(".faq-toggle-icon");

      if (question) {
        question.addEventListener("click", () => {
          if (item.classList.contains("open")) {
            // Close if already open
            item.classList.remove("open");
            if (icon) icon.textContent = "+";
          } else {
            // Close others and open this one
            closeAll();
            item.classList.add("open");
            if (icon) icon.textContent = "–";
          }
        });
      }
    });

    // Open first FAQ by default
    if (faqItems.length) {
      closeAll();
      faqItems[0].classList.add("open");
      const firstIcon = faqItems[0].querySelector(".faq-toggle-icon");
      if (firstIcon) firstIcon.textContent = "–";
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (window.jQuery && typeof jQuery.fn.slick === 'function') {
      jQuery('.announcement-slider').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        infinite: true,
        slidesToShow: 1,
        adaptiveHeight: true
      });
    } else {
      console.warn('Slick slider is not loaded.');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
